import { Component, OnInit } from '@angular/core';
import { ModeRenduService } from './mode-rendu.service';
import * as moment from 'moment';
import { UntypedFormGroup } from '@angular/forms';
import { FormulaireService } from '../formulaire.service';

@Component({
  selector: 'bis-impression-saisie',
  templateUrl: './impression-saisie.component.html',
  styleUrls: ['./impression-saisie.component.css']
})
export class ImpressionSaisieComponent implements OnInit {
  date: moment.Moment;
  rootForm: UntypedFormGroup;
  constructor(
    public modeRenduService: ModeRenduService,
    private formulaireService: FormulaireService
    ) { }

  ngOnInit() {
    this.date = moment();
    moment.locale('fr');
    this.rootForm = this.formulaireService.getRootForm();
  }
  get momentImpression(): Date {
    return this.date.toDate();
  }

}
